import styled from 'styled-components'
import { rem } from 'polished'

/** Match the compact search widget when the flight panel becomes too cramped. */
export const COMPACT_FLIGHT_WIDGET_MAX_WIDTH = 480
export const flightResultsWide = `@container chat-flight-results (min-width: ${rem(COMPACT_FLIGHT_WIDGET_MAX_WIDTH)})`

export const FlightResultsControls = styled.div`
  container: chat-flight-results / inline-size;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`
